import { digestDetail } from "./digest_reducer";

export const digest_action = (query) => async (dispatch) => {
    try {
        dispatch(digestDetail(query));
    } catch (err) {
        const error = {
            code: 0,
            message: typeof err == 'object' ? err.message : err,
        };
        throw error;
    }
};
